import { render, staticRenderFns } from "./RequestReturnGoodsList.vue?vue&type=template&id=7d5d79a4&scoped=true"
import script from "./RequestReturnGoodsList.vue?vue&type=script&lang=js"
export * from "./RequestReturnGoodsList.vue?vue&type=script&lang=js"
import style0 from "./RequestReturnGoodsList.vue?vue&type=style&index=0&id=7d5d79a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5d79a4",
  null
  
)

export default component.exports